export const DEFAULT_NOTE_THEME = 'sticky-note-deck';

const themes = new Set([
  'outline-light',
  'outline-dark',
  'card-folder-light',
  'card-folder-dark',
  DEFAULT_NOTE_THEME,
  'monochrome-sticky-note-deck',
  'depth-sticky-note-deck',
  'depth-sticky-note-deck-dark',
  'large-card',
  'wood-deck',
  'umi-deck',
  'fancy-cat',
]);

// テーマ名と、CSS のレイアウト種別（body[data-layout]）の対応。
// 記載のないテーマは 'outline' レイアウトになる。
const layoutByTheme = new Map([
  ['card-folder-light', 'card-folder'],
  ['card-folder-dark', 'card-folder'],
  ['sticky-note-deck', 'sticky-note-deck'],
  ['monochrome-sticky-note-deck', 'sticky-note-deck'],
  ['depth-sticky-note-deck', 'sticky-note-deck'],
  ['depth-sticky-note-deck-dark', 'sticky-note-deck'],
  ['large-card', 'large-card'],
  ['wood-deck', 'wood-deck'],
  ['umi-deck', 'umi-deck'],
  ['fancy-cat', 'fancy-cat'],
]);

// 付箋デッキ(深度別単色)で、深さごとに回す色の数。Flutter 版の depthColors と同じ数にする。
const DEPTH_TONE_COUNT = 6;

// 深さ（最上位が 0）から色番号を決める。CSS は data-depth-tone の値で紙色を切り替える。
export function depthToneFor(depth: number): string {
  return String(Math.max(0, depth) % DEPTH_TONE_COUNT);
}

function normalizeTheme(value) {
  if (value === 'dark') return 'outline-dark';
  if (value === 'light') return 'outline-light';
  return themes.has(value) ? value : 'outline-light';
}

export function createThemeController({ themeButtons = null, onThemeChange }) {
  function applyTheme(theme, notify = true) {
    const selectedTheme = normalizeTheme(theme);
    const isDark = selectedTheme.endsWith('-dark');
    document.body.dataset.theme = selectedTheme;
    document.body.dataset.colorScheme = isDark ? 'dark' : 'light';
    document.body.dataset.layout = layoutByTheme.get(selectedTheme) ?? 'outline';
    for (const button of themeButtons || []) {
      const selected = button.dataset.themeChoice === selectedTheme;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }
    if (notify) onThemeChange?.(selectedTheme);
  }

  function selectTheme(theme) {
    const selectedTheme = normalizeTheme(theme);
    applyTheme(selectedTheme);
    return selectedTheme;
  }

  return { applyTheme, selectTheme };
}
